/** Route guard that redirects unauthenticated users to /login. */
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import LoadingIcon from '@/foundation/ui/LoadingIcon';

export function RequireAuth() {
  const { loading, isAuthed } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        className="flex min-h-dvh items-start justify-center pt-[28vh]"
        style={{ background: 'var(--color-bg)' }}
      >
        <LoadingIcon size="lg" />
      </div>
    );
  }

  if (!isAuthed) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
